export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_ASYNC_COIN_BALANCE = 'SET_ASYNC_COIN_BALANCE';
export const SET_ETHEREUM_BALANCE = 'SET_ETHEREUM_BALANCE';
export const SET_TOTAL_SUPPLY = 'SET_TOTAL_SUPPLY';
export const SET_IS_CONTRACT_OWNER = 'SET_IS_CONTRACT_OWNER';
export const SET_CONTRACT_ETHEREUM_BALANCE = 'SET_CONTRAC_ETHEREUM_BALANCE';
export const SET_ADDRESS_ALLOWED_TO_BUY_COINS = 'SET_ADDRESS_ALLOWED_TO_BUY_COINS';

let initialState = {
  currentAccount: null,
  asyncCoinBalance: null,
  ethereumBalance: null,
  totalSupply: null,
  isContractOwner: false,
  contractEthereumBalance: null,
  canBuyCoins: null
};

function accountReducer (state = initialState, action) {
  switch (action.type) {
    case SET_ADDRESS:
      return {...state, currentAccount: action.payload};
    case SET_ASYNC_COIN_BALANCE:
      return {...state, asyncCoinBalance: action.payload};
    case SET_ETHEREUM_BALANCE:
      return {...state, ethereumBalance: action.payload};
    case SET_TOTAL_SUPPLY:
      return {...state, totalSupply: action.payload};
    case SET_IS_CONTRACT_OWNER:
      return {...state, isContractOwner: action.payload};
    case SET_CONTRACT_ETHEREUM_BALANCE:
      return {...state, contractEthereumBalance: action.payload};
    case SET_ADDRESS_ALLOWED_TO_BUY_COINS:
      return {...state, canBuyCoins: action.payload};
    default:
      return state;
  }
}

export default accountReducer;


// WEBPACK FOOTER //
// ./src/storage/AccountReducer.js